module.exports = __webpack_public_path__ + "img/white_icon.add1d3d0.svg";